import {
  Button,
  Group,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";
import { notifications } from "@mantine/notifications";
import PopOver from "../../../../components/View/PopOver";
import BackButton from "../../../../components/View/BackButton";
import { IconFileImport, IconHtml } from "@tabler/icons-react";
import { FileUploader } from "react-drag-drop-files";

const HtmlImporterLocal = ({ onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null); // State to hold the uploaded file

  const onSubmit = (e, closePopover) => {
    e.preventDefault();
    e.stopPropagation();

    if (!file) return;

    setLoading(true);

    // Initialize FileReader to read the file locally
    const reader = new FileReader();

    reader.onload = (event) => {
      const newHtml = event.target.result; // This is the raw HTML string
      
      notifications.show({
        message: lang.model_emails.get_from_url.success,
        color: "green",
      });
      
      onFinish(newHtml);
      setFile(null); // Reset the file state
      closePopover();
      setLoading(false);
    };

    reader.onerror = () => {
      notifications.show({
        message: "Error reading file",
        color: "red",
      });
      setLoading(false);
    };

    // Read the file as a plain text string
    reader.readAsText(file);
  };

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Tooltip label={lang.model_emails.get_from_url.button_tooltip_local}>
          <Button
            variant="light"
            ref={ref}
            onClick={handleOpen}
            radius={"md"}
            leftSection={<IconFileImport size={16} />}
          >
            <IconHtml size={18} />
          </Button>
        </Tooltip>
      )}
      popoverChildren={(closePopover) => (
        <Stack
          component={"form"}
          onSubmit={(e) => onSubmit(e, closePopover)}
          gap={"xs"}
          p={"md"}
          pb={0}
          w={500}
        >
          <Text fw={600} size="sm">
            {lang.models.html.text} <br />
            <span style={{ color: "red" }}>{lang.models.html.text2}</span>
          </Text>

          {/* File uploader (single, html & htm only) */}
          <FileUploader
            handleChange={(selectedFile) => setFile(selectedFile)}
            name="file"
            types={["HTML", "HTM"]}
            multiple={false}
          />

          {/* Visual feedback so the user knows the file is staged */}
          {file && (
            <Text size="md">
              {file.name}
            </Text>
          )}

          <Group justify="end" mt={"md"}>
            <BackButton 
              onClick={() => {
                setFile(null); // Clear file if they cancel
                closePopover();
              }} 
              size="sm" 
            />
            {/* Disabled if no file is selected */}
            <Button type="submit" loading={loading} disabled={!file} size="sm">
              {lang.model_emails.get_from_url.dialog.submit_button}
            </Button>
          </Group>
        </Stack>
      )}
    />
  );
};

export default HtmlImporterLocal;